module.exports = __webpack_public_path__ + "media/images/company/cp22-15a1546859fbfd499b4b98e34e5eaec0.png";